import { ImageGalleryItem, ImagePreviewState } from 'owa-sxsdata';

export default function isImageGalleryItemCurrentImagePreview(
    imageGalleryItem: ImageGalleryItem,
    viewState: ImagePreviewState
): boolean {
    if (imageGalleryItem.previewUrl && imageGalleryItem.previewUrl === viewState.previewUrl) {
        return true;
    }

    if (imageGalleryItem.id && viewState.id && imageGalleryItem.id === viewState.id) {
        return true;
    }

    return false;
}
